import React from "react";

const BillIcon = ({ size, color, opacity }) => {
  const iconColor = color || "#1500ff";
  const iconOpacity = opacity && opacity !== "none" ? opacity : 1;
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 48 48" 
      width={size || 20} 
      height={size || 20}
      fill={iconColor}
      opacity={iconOpacity}
    >
      <path d="M37,2H11A5,5,0,0,0,6,7V25a1,1,0,0,0,1,1h7V45a1,1,0,0,0,1.51.86l4.43-2.66,3.46,2.6a1,1,0,0,0,1.2,0L28,43.24l3.49,2.51a1,1,0,0,0,1.18,0l3.38-2.54,4.43,2.66A1,1,0,0,0,42,45V7A5,5,0,0,0,37,2ZM8,24V7a3,3,0,0,1,6,0V24ZM40,43.23l-3.49-2.09a1,1,0,0,0-1.11.06l-3.33,2.5-3.49-2.51a1,1,0,0,0-1.18,0L24,43.75,20.6,41.2a1,1,0,0,0-1.11-.06L16,43.23V7a4.92,4.92,0,0,0-1-3H37a3,3,0,0,1,3,3ZM28,8a9,9,0,1,0,9,9A9,9,0,0,0,28,8Zm0,16a7,7,0,1,1,7-7A7,7,0,0,1,28,24Zm1-11h2v2H27v1h3a1,1,0,0,1,1,1v3a1,1,0,0,1-1,1H29v1H27V21H25V19h4V18H26a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1h1V12h2ZM19,30H37v2H19Zm0,6H37v2H19Z"></path>
    </svg>
  );
};

BillIcon.defaultProps = {
  size: 20,
  color: "#1500ff",
  opacity: "none",
};

export default BillIcon;

